import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getInventoryInfo, __config_inventory } from '../../../redux/reducers';
import * as InventoryAction from '../../../redux/actions/account/actions-inventory';

@Component({
  standalone: false,
  selector: 'app-inventory-page',
  templateUrl: './inventory-page.component.html',
  styleUrls: ['./inventory-page.component.scss']
})
export class InventoryPageComponent implements OnInit {
  public config$: Observable<any>;
  public inventory$: Observable<any>;

  constructor(private readonly store: Store<any>) {
    this.store.dispatch(new InventoryAction.GetInventory());
  }

  ngOnInit() {
    this.config$ = this.store.pipe(select(__config_inventory));
    this.inventory$ = this.store.pipe(select(getInventoryInfo));
  }
}
